import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

export const saveContactInquiry = async (formData) => {
  const contactData = {
    name: formData.name.trim(),
    company: formData.company.trim(),
    email: formData.email.trim(),
    phone: formData.phone.trim(),
    message: formData.message.trim(),
    serviceType: "SAP Services",
    status: "new",
    createdAt: serverTimestamp(),
  };

  const docRef = await addDoc(collection(db, "contactInquiries"), contactData);

  return docRef.id;
};
